import Axios from 'axios'
import requestPrefix from '../requestPrefix'
const FileUrl = requestPrefix.fileUrl

export default {
  /**
   * 新增
   * @param data
   */
  save(data) {
    return Axios({
      url: FileUrl + '/save',
      method: 'post',
      data: data
    })
  },
  /**
   * 获取一条数据
   * @param data
   */
  page(data) {
    return Axios({
      url: FileUrl + '/get',
      method: 'get',
      params: data
    })
  },
  /**
   * 删除
   * @param data
   */
  remove(data) {
    return Axios({
      url: FileUrl + '/remove',
      method: 'get',
      params: data
    })
  },
  /**
   * 获取uuid
   * @param data
   */
  getUUid() {
    return Axios({
      url: FileUrl + '/getUUid',
      method: 'get'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/file/file.js